import React from 'react';
import { Link } from 'react-router-dom';
import boardDevice from '../../assets/board-device.jpg';
import device from '../../assets/device.png';
import fuelCard from '../../assets/fuel-card.png';
import fuelControl from '../../assets/fuel-control.png';
import fuelDashboard from '../../assets/fuel-dashboard.png';
import fuelSafer from '../../assets/fuelSafer.png';
import petrol from '../../assets/petrol.png';
import tracksmart from '../../assets/tracksmart.jpg';
import { solutions } from './homeData';

const defaultSolutionImages = {
  fuelMonitoring: fuelSafer,
  fuelAutomation: fuelControl,
  constructionFuel: boardDevice,
  aisDevice: device,
  wasteManagement: tracksmart,
  vehicleTracking: fuelDashboard,
  consignmentTracking: fuelCard,
  videoTelematics: petrol,
  schoolMonitoring: tracksmart,
};

function SmartSolutionsCarousel({ pageImages = {} }) {
  const solutionImages = {
    ...defaultSolutionImages,
    ...pageImages,
  };

  return (
    <section
      id="solutions"
      className="mx-auto w-full max-w-[1400px] px-3 py-8 sm:px-4 sm:py-10 lg:px-5 lg:py-12"
    >
      <div className="border-b border-[#d7d0c8] pb-4 sm:pb-5">
        <div className="min-w-0">
          <h2 className="text-2xl font-semibold text-[#111111] sm:text-3xl">
            Our Smart Solutions
          </h2>

          <p className="mt-2 max-w-4xl text-[11px] leading-5 text-[#4e4741] sm:text-xs">
            We offer end-to-end solutions for modern fleet operations - including real-time GPS tracking,
            geofence alerts, and driver behavior analysis through an advanced telematics platform.
          </p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:gap-5">
        {solutions.map((solution) => (
          <Link
            key={solution.number}
            to={solution.href}
            aria-label={`Open ${solution.title} page`}
            className="group flex h-full min-h-[390px] flex-col overflow-hidden rounded-2xl border border-[#eadfd4] bg-white text-left no-underline shadow-[0_10px_30px_rgba(17,17,17,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-[#df8b2d]/60 hover:shadow-[0_16px_42px_rgba(223,139,45,0.18)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#df8b2d]/45"
          >
            <div className="relative overflow-hidden bg-[#fff5e9]">
              <img
                src={solutionImages[solution.imageKey]}
                alt={solution.title}
                className="h-[190px] w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-[205px]"
              />

              <span className="absolute left-4 top-4 rounded-full bg-white px-3 py-1 text-xs font-semibold text-[#111111] shadow-sm">
                {solution.number}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-5 sm:p-6">
              <div className="flex items-start gap-2.5">
                <span className="text-lg leading-none" aria-hidden="true">
                  {solution.icon}
                </span>

                <h3 className="text-base font-semibold leading-6 text-[#111111] sm:text-lg">
                  {solution.title}
                </h3>
              </div>

              <p className="mt-3 line-clamp-4 text-xs leading-6 text-[#4e4741] sm:text-[13px]">
                {solution.text}
              </p>

              <span className="mt-auto inline-flex items-center gap-2 pt-5 text-xs font-semibold text-[#df8b2d] transition-colors duration-200 group-hover:text-[#111111]">
                Learn More <span aria-hidden="true">&rarr;</span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default SmartSolutionsCarousel;
